module.exports = __webpack_public_path__ + "img/Brazil.4c70e20b.png";